import script from "./testView.vue?vue&type=script&setup=true&lang=js"
export * from "./testView.vue?vue&type=script&setup=true&lang=js"

import "./testView.vue?vue&type=style&index=0&id=a461573a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a461573a"]])

export default __exports__